import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NContracts } from '../interfaces/services/contracts.interfaces'
import { sortStringsAlphabetically } from '../helpers/sorting'

export const getContractsPerSociety = (
  societyId: string
): Promise<AxiosResponse<NContracts.NGetPerSocieties.IResponse>> => {
  const body: NContracts.NGetPerSocieties.IRequestBody = {
    societyIds: [societyId],
  }
  return axiosAuth.post<NContracts.NGetPerSocieties.IResponse>(
    createUrl(`/contracts/get-per-societies`),
    body
  )
}

export const getContract = (
  id: string
): Promise<AxiosResponse<NContracts.NGetById.IResponse>> => {
  return axiosAuth.get<NContracts.NGetById.IResponse>(
    createUrl(`/contracts/contract/${id}`)
  )
}

export const createContract = (
  body: NContracts.NCreate.IRequestBody
): Promise<AxiosResponse<NContracts.NCreate.IResponse>> => {
  return axiosAuth.post<NContracts.NCreate.IResponse>(
    createUrl(`/contracts/contract`),
    body
  )
}

export const updateContract = (params: {
  id: string
  body: NContracts.NPatch.IRequestBody
}): Promise<AxiosResponse<NContracts.NPatch.IResponse>> => {
  return axiosAuth.patch<NContracts.NPatch.IResponse>(
    createUrl(`/contracts/contract/${params.id}`),
    params.body
  )
}

export const deleteContract = (
  id: string
): Promise<AxiosResponse<NContracts.NDelete.IResponse>> => {
  return axiosAuth.delete<NContracts.NDelete.IResponse>(
    createUrl(`/contracts/contract/${id}`)
  )
}

export const contractQueries = {
  getContractsPerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'contract', entity: 'society', societyId }],
      enabled: !!societyId,
      queryFn: async ({ queryKey }) => {
        const { data } = (await getContractsPerSociety(queryKey[0].societyId!))
          .data
        data?.sort((a, b) => {
          if (a.status === 'active' && b.status !== 'active') {
            return -1
          }
          if (a.status !== 'active' && b.status === 'active') {
            return 1
          }
          return sortStringsAlphabetically(a.title, b.title)
        })
        return data
      },
    }),
  getContract: (contractId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'contract', entity: 'detail', contractId }],
      enabled: !!contractId,
      queryFn: async ({ queryKey }) => {
        return (await getContract(queryKey[0].contractId!)).data.data
      },
    }),
}
